import { map } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { vacantRentalObjectCommand } from '../../model/const/command';
import { LeaseAgreementCategory } from '../../model/const/enums';
import { VacantRentalObjectService } from './../data/vacant-period.service';
import { VacantDwellingService } from '../data/vacant-dwelling.service';

@Injectable()
export class CreateContractCommandHandler implements ICommandHandler {
  constructor(
    private _messageDispather: ComponentMessageDispatcher,
    private _navigation: NavigationService,
    private _service: VacantRentalObjectService,
    private _dwellingService: VacantDwellingService,
    @Inject('category') category: LeaseAgreementCategory
  ) {
    this._path = this._getPath(category);
    this._cat = category;
  }

  private readonly _path: string[];
  private readonly _cat: LeaseAgreementCategory;

  private _getPath(category: LeaseAgreementCategory) {
    let segment = '';
    switch (category) {
      case LeaseAgreementCategory.Block:
      case LeaseAgreementCategory.Dwelling:
      case LeaseAgreementCategory.Parking:
      case LeaseAgreementCategory.Premises:
        segment = LeaseAgreementCategory[category].toLowerCase();
        break;

      case LeaseAgreementCategory.Other:
        segment = 'other-rental-object';
        break;

      default:
        throw new Error(`The specified contract category is not supported. Category: ${category}`);
    }
    return [segment, 'contracts', 'add'];
  }

  canExecute(command: Command): boolean {
    return command.id == vacantRentalObjectCommand.createContract;
  }

  execute(command: Command): Observable<void> {
    switch (this._cat) {
      case LeaseAgreementCategory.Dwelling:
        return this._dwellingService.getById(command.context.id).pipe(
          map(rentalObject => {
            this._navigation.navigate(this._path).then(result => {
              if (result) {
                this._messageDispather.send(rentalObject);
              }
            });
          })
        );
      case LeaseAgreementCategory.Parking:
      case LeaseAgreementCategory.Premises:
      case LeaseAgreementCategory.Other:
        return this._service.getById(command.context.id).pipe(
          map(rentalObject => {
            this._navigation.navigate(this._path).then(result => {
              if (result) {
                this._messageDispather.send(rentalObject);
              }
            });
          })
        );
      default:
        throw new Error(`The specified contract category is not supported. Category: ${this._cat}`);
    }
  }
}
